import { useEffect, useRef, useState } from "react";
import { createConnection, getConnection } from "../services/signalRService";
import { HUB_URL } from "../Api/ApiConfig";

let hubUrl=HUB_URL;

const useSignalR = () => {
  const [isConnected, setIsConnected] = useState(false);
  const connectionRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const connection = createConnection(hubUrl, token);
    connectionRef.current = connection;

    connection.onreconnecting(() => setIsConnected(false));
    connection.onreconnected(() => setIsConnected(true));
    connection.onclose(() => setIsConnected(false));

    connection
      .start()
      .then(() => {
        console.log("SignalR Connected");
        setIsConnected(true);
      })
      .catch((err) => console.error("SignalR Error:", err));

    return () => connection.stop();
  }, [hubUrl]);

  // Listen to an event
  const on = (event, callback) => {
    connectionRef.current?.on(event, callback);
  };

  // Stop listening
  const off = (event) => {
    connectionRef.current?.off(event);
  };

  // Call server method
  const invoke = async (event, ...args) => {
    try {
      return await connectionRef.current?.invoke(event, ...args);
    } catch (err) {
      console.error(`Invoke ${event} failed:`, err);
    }
  };

  return { isConnected, on, off, invoke };
};

export default useSignalR;
